import { isArray, isString, lowerCase } from 'lodash-es';
import { stringSimilarity } from 'string-similarity-js';

const TYPE_ERROR = 'The constructor requires two string arrays';

interface ComparedValue {
  search: string;
  value: string;
  searchCoeficient: number;
}

export class StringCompare {
  private readonly SEARCH_COEFICIENT = 0.5;
  private searchArray: string[];
  private valuesArray: string[];

  constructor(searchArray: string[], valuesArray: string[]) {
    if (!this.isStringArray(searchArray) || !this.isStringArray(valuesArray)) {
      throw new TypeError(TYPE_ERROR);
    }
    this.searchArray = searchArray;
    this.valuesArray = valuesArray;
  }

  public compareArrays(): ComparedValue[] {
    const searchCoeficients = this.searchArray.flatMap(search =>
      this.valuesArray.map(value => ({
        search,
        value,
        searchCoeficient: stringSimilarity(lowerCase(search), lowerCase(value)),
      }))
    );

    return searchCoeficients
      .sort(this.sortFunction)
      .filter(search => search.searchCoeficient >= this.SEARCH_COEFICIENT);
  }

  private isStringArray(stringArray: string[]): boolean {
    if (!isArray(stringArray)) return false;
    return stringArray.every(i => isString(i));
  }

  private sortFunction(search1: ComparedValue, search2: ComparedValue): number {
    return search2.searchCoeficient - search1.searchCoeficient;
  }
}
